/**
 * Auth route layout component
 * Split-screen layout with branding (left) and form content (right)
 * Used by all authentication pages (login, register, forgot-password)
 */

import { Outlet } from '@tanstack/react-router';

import { AuthBranding } from './components/AuthBranding';
import './AuthRouteLayout.scss';

export function AuthRouteLayout() {
  return (
    <div className="auth-route-layout">
      <AuthBranding />

      <div className="auth-route-content">
        <div className="auth-route-content-wrapper">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
